import React from 'react'
import s from './projectResult.m.scss'
import { Project } from 'components/projectResults/Project'
import clsx from 'clsx'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'

export function ProjectResult({
  Logoname,
  Beschreibung,
  Link1Text,
  Link1URL,
  Link2Text,
  Link2URL,
  Link3Text,
  Link3URL
}: Project) {
  let logo = require('images/logos/missing.svg')

  try {
    logo = require('images/logos/' + Logoname + '.svg')
  } catch (e) {
    if (e.code === 'MODULE_NOT_FOUND') {
      console.warn(`Logo with name '${Logoname}' not found.`)
    } else {
      throw e
    }
  }

  return (
    <article className={clsx('ui vertical segment', s.projectResult)}>
      <img src={logo} alt='' className={clsx(s.image)} />
      <div className='content'>
        <div
          className='description'
          dangerouslySetInnerHTML={{ __html: Beschreibung }}
        />
        <div className='ui icon relaxed link list'>
          <ExternalLink url={Link1URL} text={Link1Text} />
          <ExternalLink url={Link2URL} text={Link2Text} />
          <ExternalLink url={Link3URL} text={Link3Text} />
        </div>
      </div>
    </article>
  )
}

function ExternalLink({ url, text = url }: { url: string; text: string }) {
  if (!url) {
    return null
  }

  return (
    <a href={url} target='_blank' rel='noopener noreferrer' className='item'>
      <i className='external link alternate icon' />
      <span className='content'>{text}</span>
    </a>
  )
}
